import { render, staticRenderFns } from "./editSubject.vue?vue&type=template&id=06725e17&"
import script from "@viewJs/examRegisteation/editSubject.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/editSubject.js?vue&type=script&lang=js&"
import style0 from "./editSubject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports